import React, { memo, useContext } from 'react';
import { IApiTradingPlatformType } from '@api/interfaces/data-contracts';
import { apiImageUserService } from '@api/services/imageUserService.apiService';
import { ArrowIcon } from '@components-library/Icons/iconsComponents';
import { AccountCreateContext } from '@components-member/TradingAccounts/AccountCreate/context';
import cn from 'classnames';
import styles from './tradingPlatform.module.scss';

interface ITradingPlatform {
  title: string;
  description: string;
  platform: IApiTradingPlatformType;
  id: number;
  imageUniqueId: string;
  changeStepHandler: () => void;
}

export const TradingPlatform = memo(
  ({ description, imageUniqueId, title, platform, changeStepHandler }: ITradingPlatform): JSX.Element => {
    const { selectedPlatformType, setSelectedPlatformType } = useContext(AccountCreateContext);
    const imageSrc = apiImageUserService.getMembersAreaImageSrc({
      imageUniqueId,
    });

    const onClickHandler = () => {
      setSelectedPlatformType(platform);
      changeStepHandler();
    };

    return (
      <div
        onClick={onClickHandler}
        className={cn(styles.tradingPlatform, { [styles.tradingPlatform_active]: selectedPlatformType === platform })}>
        <div className={styles.tradingPlatform__wrapper}>
          <img className={styles.tradingPlatform__image} src={imageSrc} alt={title} />
          <div className={styles.tradingPlatform__textWrapper}>
            <div className={styles.tradingPlatform__header}>
              <h4 className={styles.tradingPlatform__title}>{title}</h4>
              <ArrowIcon direction="right" className={styles.tradingPlatform__icon} />
            </div>
            <div
              className={styles.tradingPlatform__description}
              dangerouslySetInnerHTML={{ __html: description || '' }}
            />
          </div>
        </div>
      </div>
    );
  },
);
